export const LOADING = 'landing.LOADING';
export const LOADED = 'landing.LOADED';